
import { createClient } from '@supabase/supabase-js';

const getEnv = (key: string): string => {
  // Em produção (Vite), import.meta.env é a forma oficial
  const metaEnv = (import.meta as any).env;
  if (metaEnv) {
    const viteKey = `VITE_${key}`;
    if (metaEnv[viteKey]) return String(metaEnv[viteKey]);
    if (metaEnv[key]) return String(metaEnv[key]);
  }

  // Fallback para ambientes de build/node
  try {
    if (typeof process !== 'undefined' && process.env && process.env[key]) {
      return String(process.env[key]);
    }
  } catch (e) {}

  return '';
};

const supabaseUrl = getEnv('SUPABASE_URL');
const supabaseAnonKey = getEnv('SUPABASE_ANON_KEY');

export const isConfigured = Boolean(supabaseUrl && supabaseAnonKey);

export const supabase = isConfigured 
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;

if (!isConfigured) {
  console.warn('4Nutri Cloud: Variáveis VITE_SUPABASE_URL ou VITE_SUPABASE_ANON_KEY não encontradas.');
}
